/*
 * @Description:保险接口
 * @Version: 2.0
 * @Author: liangdengke
 * @Date: 2022-07-09 13:47:57
 * @LastEditors: your Name
 * @LastEditTime: 2022-08-01 22:18:50
 */
import {
    getOccupationCodeListFn,
     personnelInfoFn,
     saveFn,
     submitListFn,
     approveListFn,
     getInsuranceTechnologyUserListFn,
     technologyCreateFn,
     classificationListFn,
     notificationSaveFn,
     insuranceCopyFn,
     insuranceSubmitFn,
     auditSaveFn,
     insuranceInfoSaveFn,
     getInsuranceTypeFn,
     notificationSubmitFn,
     withdrawalFn,
     getInsuranceTechnologyMainUserListFn,
     informationFn,
    } from "@/serves/insurance.js";
export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    // 获取职业
    async GetOccupationCodeList({ }, params) {
        return new Promise((resolve, reject) => {
            getOccupationCodeListFn(params).then(async data => {
            resolve(data);
          }).catch(err => {
            reject(err);
          });
        });
      },
      //获取客户信息
    async PersonnelInfo({ }, params) {
        return new Promise((resolve, reject) => {
            personnelInfoFn(params).then(async data => {
            resolve(data);
          }).catch(err => {
            reject(err);
          });
        });
      },
      //客户信息保存
    async Save({ }, params) {
        return new Promise((resolve, reject) => {
            saveFn(params).then(async data => {
            resolve(data);
          }).catch(err => {
            reject(err);
          });
        });
      },
      //获取待提交表格信息
    async SubmitList({ }, params) {
        return new Promise((resolve, reject) => {
            submitListFn(params).then(async data => {
            resolve(data);
          }).catch(err => {
            reject(err);
          });
        });
      },
      //获取待审核表格信息
    async ApproveList({ }, params) {
        return new Promise((resolve, reject) => {
            approveListFn(params).then(async data => {
            resolve(data);
          }).catch(err => {
            reject(err);
          });
        });
      },
      //获取家庭资料信息
    async GetInsuranceTechnologyUserList({ }, params) {
        return new Promise((resolve, reject) => {
            getInsuranceTechnologyUserListFn(params).then(async data => {
            resolve(data);
          }).catch(err => {
            reject(err);
          });
        });
      },
      //保存家庭资料信息
    async TechnologyCreate({ }, params) {
        return new Promise((resolve, reject) => {
            technologyCreateFn(params).then(async data => {
            resolve(data);
          }).catch(err => {
            reject(err);
          });
        });
      },
      //保险分类
    async ClassificationList({ }, params) {
        return new Promise((resolve, reject) => {
            classificationListFn(params).then(async data => {
            resolve(data);
          }).catch(err => {
            reject(err);
          });
        });
      },
      //保存告知事项
    async NotificationSave({ }, params) {
        return new Promise((resolve, reject) => {
            notificationSaveFn(params).then(async data => {
            resolve(data);
          }).catch(err => {
            reject(err);
          });
        });
      },
      //复制保单
    async InsuranceCopy({ }, params) {
        return new Promise((resolve, reject) => {
            insuranceCopyFn(params).then(async data => {
            resolve(data);
          }).catch(err => {
            reject(err);
          });
        });
      },
      //表格中的提交
    async InsuranceSubmit({ }, params) {
        return new Promise((resolve, reject) => {
            insuranceSubmitFn(params).then(async data => {
            resolve(data);
          }).catch(err => {
            reject(err);
          });
        });
      },
      //核保保存
    async AuditSave({ }, params) {
        return new Promise((resolve, reject) => {
            auditSaveFn(params).then(async data => {
            resolve(data);
          }).catch(err => {
            reject(err);
          });
        });
      },
      //核保保存
    async InsuranceInfoSave({ }, params) {
        return new Promise((resolve, reject) => {
            insuranceInfoSaveFn(params).then(async data => {
            resolve(data);
          }).catch(err => {
            reject(err);
          });
        });
      },
      //获取险种
      GetInsuranceType({ }, params) {
        return new Promise((resolve, reject) => {
          getInsuranceTypeFn(params).then(async data => {
            resolve(data);
          }).catch(err => {
            reject(err);
          });
        });
      },
      //告知事项页面提交投保
      NotificationSubmit({ }, params) {
        return new Promise((resolve, reject) => {
          notificationSubmitFn(params).then(async data => {
            resolve(data);
          }).catch(err => {
            reject(err);
          });
        });
      },
      //撤回提交
      Withdrawal({ }, params) {
        return new Promise((resolve, reject) => {
          withdrawalFn(params).then(async data => {
            resolve(data);
          }).catch(err => {
            reject(err);
          });
        });
      },
      //获取财务规划列表数据
      GetInsuranceTechnologyMainUserList({ }, params) {
        return new Promise((resolve, reject) => {
          getInsuranceTechnologyMainUserListFn(params).then(async data => {
            resolve(data);
          }).catch(err => {
            reject(err);
          });
        });
      },
      //获取财务规划列表数据
      Information({ }, params) {
        return new Promise((resolve, reject) => {
          informationFn(params).then(async data => {
            resolve(data);
          }).catch(err => {
            reject(err);
          });
        });
      },

  },
  getters: {

  }
};
